export default __webpack_public_path__ + "static/media/GettyImages-1146315260-734ae3c6382448f7adfee76617db0d68.0a710d56.png";